import Procedimientos from './Procedimientos';
export default Procedimientos;